<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <v-container fluid>
    <v-container id="dropdown" grid-list-xl>
      <v-layout row wrap align-center>
        <v-flex xs12 sm4>
          <label class="label text-left w-100">{{ $language('pages.employees.departmentLabel') }}</label>
          <v-overflow-btn
            :value="department"
            :items="getDepartments()"
            item-text="Number"
            :return-object="true"
            editable
            :label="$isLoading('departments') ? 'Loading...' : 'Choose Department'"
            :loading="$isLoading('departments')"
            @input="setDepartmentDebounce"
          ></v-overflow-btn>
        </v-flex>
      </v-layout>
    </v-container>

    <v-progress-linear v-if="$isLoading('created')" :height="2" :indeterminate="true"></v-progress-linear>

    <v-data-table
      v-else
      :headers="headers"
      :items="items"
      hide-actions
      class="elevation-1 text-left w-100"
      :pagination.sync="pagination"
      :loading="$isLoading('departments')"
    >
      <template slot="progress">
        <div class="v-progress-linear">
          <div class="v-progress-linear__bar">
            <div class="v-progress-linear__bar__indeterminate v-progress-linear__bar__indeterminate--active">
              <div class="v-progress-linear__bar__indeterminate long primary"></div>
              <div class="v-progress-linear__bar__indeterminate short primary"></div>
            </div>
          </div>
        </div>
      </template>

      <template v-slot:items="{ index, item }">
        <tr>
          <td>
            <div>{{ item.info }}</div>
          </td>

          <td v-for="(month, i) in months" :key="i" class="pa-0">
            <input
              class="input-field"
              :class="{ 'input--error': employees[item.type][department.ID][month.format] === '' }"
              :ref="index + '-' + i"
              @blur="update($event.target, item.type, month.format)"
              @keydown="focusTo($event, index, i)"
              @focus="$event.target.select()"
              @keypress="$helpers.isFloat"
              type="number"
              :value="employees[item.type][department.ID][month.format]"
              min="0"
              step="1"
              lang="sv-SE"
            />
            <div v-if="$isLoading(item.type + '-' + month.format)" class="v-progress-linear">
              <div class="v-progress-linear__bar">
                <div class="v-progress-linear__bar__indeterminate v-progress-linear__bar__indeterminate--active">
                  <div class="v-progress-linear__bar__indeterminate long primary"></div>
                  <div class="v-progress-linear__bar__indeterminate short primary"></div>
                </div>
              </div>
            </div>
          </td>
        </tr>
      </template>

      <template slot="footer">
        <td class="font-weight-bold">
          {{ $language('pages.employees.available') }}
        </td>

        <td v-for="(month, index) in months" :key="index" class="text-left font-weight-bold">
          {{ employees.available[department.ID][month.format] }}
        </td>
      </template>
    </v-data-table>
  </v-container>
</template>

<script>
import { mapState } from 'vuex';
import tableNavigation from '@/mixin/tableNavigation';
import loading from '@/mixin/loading';
import departments from '@/mixin/departments';
import employees from './employees';

export default {
  name: 'employees',
  mixins: [tableNavigation, loading, departments, employees],
  data() {
    const months = this.$getMonths();
    return {
      months,
      headers: [
        { text: '', sortable: false, key: 'info', value: 'info' },
        ...months.map(({ format }) => ({ text: format, sortable: false, value: format })),
      ],
      items: [
        { type: 'employed', info: this.$language('pages.employees.employed') },
        { type: 'absence', info: this.$language('pages.employees.absence') },
      ],
      pagination: { rowsPerPage: 25 },
    };
  },
  computed: {
    ...mapState('auth', ['user']),
  },
  methods: {
    async update(input, type, month) {
      const oldValue = this.employees[type][this.department.ID][month];
      const newValue = parseFloat(input.value);
      // value hasn't changed
      if (newValue === oldValue) {
        return;
      }
      // set old value if input is empty
      if (input.value === '') {
        input.value = oldValue;
        return;
      }
      try {
        await this.updateEmployees(this.department.ID, type, month, oldValue, newValue);
      } catch (err) {
        console.log(err);
        this.$store.commit('snackbar/show', (err.response && err.response.data && err.response.data.message) || err.message);
      }
    },
  },
  watch: {
    department() {
      if (this.department) {
        this.headers[0].text = this.department.Number;
      }
    },
  },
  async created() {
    document.title = this.$language('pages.employees.title');
    this.$store.commit('page/title', this.$language('pages.employees.menuTitle'));
    this.setDefaultDepartment(0);
    this.$startLoading('created');
    try {
      await Promise.all([
        this.fetchEmployees(this.fetchDepartments()),
      ]);
    } catch (err) {
      console.log(err);
      this.$store.commit('snackbar/show', (err.response && err.response.data && err.response.data.message) || err.message);
      throw err;
    }
    this.$stopLoading('created');
  },
};
</script>

<style lang="scss" scoped>
  /deep/ .v-datatable tr:first-child th:first-child {
    color: black !important;
    font-size: 16px;
  }
</style>
